export default {"src":"/_next/static/media/nurses.bdcb287d.svg","height":158,"width":237};